module.exports = __webpack_public_path__ + "static/media/oneday_1.78eb4388.png";